import { create } from "zustand";

interface SurveyQuestionnaireState {
  // Current section index
  currentSectionIndex: number;
  setCurrentSectionIndex: (index: number) => void;

  // Answers - key format: `${sectionIndex}-${questionIndex}`
  answers: Record<string, string | number | undefined>;
  setAnswers: (answers: Record<string, string | number | undefined>) => void;
  updateAnswer: (
    sectionIndex: number,
    questionIndex: number,
    value: string | number | undefined
  ) => void;

  // Toast error message
  toastError: string;
  setToastError: (error: string) => void;

  // Confirmation modal
  isConfirmationModalOpen: boolean;
  setIsConfirmationModalOpen: (isOpen: boolean) => void;

  // Submission success
  isSubmissionSuccess: boolean;
  setIsSubmissionSuccess: (isSuccess: boolean) => void;

  // Reset store
  resetStore: () => void;
}

const initialState = {
  currentSectionIndex: 0,
  answers: {},
  toastError: "",
  isConfirmationModalOpen: false,
  isSubmissionSuccess: false,
};

export const useSurveyQuestionnaireStore = create<SurveyQuestionnaireState>(
  (set) => ({
    ...initialState,

    setCurrentSectionIndex: (index: number) =>
      set({ currentSectionIndex: index }),

    setAnswers: (answers) => set({ answers }),

    updateAnswer: (sectionIndex, questionIndex, value) => {
      const answerKey = `${sectionIndex}-${questionIndex}`;
      set((state) => ({
        answers: {
          ...state.answers,
          [answerKey]: value,
        },
      }));
    },

    setToastError: (error: string) => set({ toastError: error }),

    setIsConfirmationModalOpen: (isOpen: boolean) =>
      set({ isConfirmationModalOpen: isOpen }),

    setIsSubmissionSuccess: (isSuccess: boolean) =>
      set({ isSubmissionSuccess: isSuccess }),

    resetStore: () => set(initialState),
  })
);
